import { useLocation, matchPath } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import AllRoutes from "./AllRoutes";
import Header from "./ShearedComponents/Header/Header";
import Footer from "./ShearedComponents/Footer/Footer";
import routes from "./ShearedComponents/routes";
import { useTranslation } from "react-i18next";
import { initializeApp } from "firebase/app";
import { useSelector } from "react-redux";
import { useUpdateFCMMutation } from "./services/Post";
import { getLanguage } from "./javascript/SelectLanguage";
import moment from "moment";
import "moment/locale/bn";
import "moment/locale/ar";
import ChatbotWrapper from "./chatboat/ChatbotWrapper";

function App() {
  const location = useLocation();
  const userToken = useSelector((data) => data?.local?.token);
  const [updateFcm] = useUpdateFCMMutation();

  let sessionId = localStorage.getItem("sessionId");

  const fcmToken = localStorage.getItem("fcmTokenFalconWeb");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const { t, i18n } = useTranslation();

  const [_, setRerender] = useState(0);

  useEffect(() => {
    if (i18n.language === "bn" || i18n.language === "ar") {
      moment.locale(i18n.language);
    } else {
      moment.locale("en");
    }
    setRerender((prev) => prev + 1);
  }, [i18n.language]);

  const [deviceInfo, setDeviceInfo] = useState({
    deviceName: "",
    deviceOS: "",
    OSVersion: "",
    buildNumber: "",
  });

  useEffect(() => {
    const getDeviceInfo = () => {
      const userAgent = navigator.userAgent;
      const platform = navigator.platform;

      let deviceName = platform || "Unknown Device";
      let deviceOS = "Unknown OS";
      let OSVersion = "Unknown Version";
      let buildNumber = "1.0.0";

      if (userAgent.includes("Windows NT")) {
        deviceOS = "Windows";
        OSVersion = userAgent.match(/Windows NT ([0-9.]+)/)?.[1] || "Unknown";
      } else if (userAgent.includes("Mac OS X")) {
        deviceOS = "macOS";
        OSVersion =
          userAgent.match(/Mac OS X ([0-9_]+)/)?.[1].replace(/_/g, ".") ||
          "Unknown";
      } else if (userAgent.includes("Linux")) {
        deviceOS = "Linux";
      } else if (userAgent.includes("Android")) {
        deviceOS = "Android";
        OSVersion = userAgent.match(/Android ([0-9.]+)/)?.[1] || "Unknown";
      } else if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
        deviceOS = "iOS";
        OSVersion =
          userAgent.match(/OS ([0-9_]+)/)?.[1].replace(/_/g, ".") || "Unknown";
      }

      setDeviceInfo({
        deviceName,
        deviceOS,
        OSVersion,
        buildNumber,
      });
    };

    getDeviceInfo();
  }, []);

  const handleUpdateFcm = async (token) => {
    const res = await updateFcm({
      deviceId: sessionId,
      deviceOS: "Web",
      fcmToken: fcmToken ? fcmToken : "",
      deviceName: deviceInfo.deviceName,
      OSVersion: deviceInfo.OSVersion,
      buildNumber: deviceInfo.buildNumber,
      language: getLanguage(),
      userToken: token,
    });

    console.log("res", res);
  };

  const config = {
    apiKey: "AIzaSyApR6UmqJCK0wgA5KbNN1FQOh6WUnS1Jd4",
    authDomain: "falcon-da91b.firebaseapp.com",
    projectId: "falcon-da91b",
    storageBucket: "falcon-da91b.firebasestorage.app",
    messagingSenderId: "521217718597",
    appId: "1:521217718597:web:1b3c2394c3616c8836662c",
    measurementId: "G-6L67GZ929B",
  };

  useEffect(() => {
    import("firebase/messaging").then(
      ({ getMessaging, getToken, onMessage, isSupported }) => {
        const app = initializeApp(config);
        const messaging = getMessaging(app);

        isSupported().then((support) => {
          if (support) {
            if (Notification.permission === "default") {
              Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                  console.log("Notification permission granted");
                  getFirebaseToken();
                  if (userToken && fcmToken) {
                    handleUpdateFcm(userToken);
                  }
                } else {
                  console.log("Notification permission denied");
                }
              });
            } else if (Notification.permission === "granted") {
              getFirebaseToken();
            } else {
              console.log("Notification permission not granted");
            }
          }
        });

        const getFirebaseToken = () => {
          getToken(messaging, {
            vapidKey: `${process.env.REACT_APP_VALIDFCMTOKENKEY}`,
          })
            .then((currentToken) => {
              if (currentToken) {
                localStorage.setItem("fcmTokenFalconWeb", currentToken);
              } else {
                console.log("No registration token available.");
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token. ", err);
            });
        };

        onMessage(messaging, (payload) => {
          const { body_en, body_he, type, id, image } = payload.data;

          const options = {
            body:
              i18n.language === "he"
                ? body_he
                : body_en || payload.notification.body,
            icon: payload.notification.icon,
            image: payload.notification.image,
            dir: i18n.language === "he" ? "rtl" : "ltr",
            // vibrate: true,
            vibrate: [200, 100, 200],
            silent: false,
          };
          let notification = new Notification(
            payload.notification.title,
            options
          );

          console.log("payload", payload);

          localStorage.setItem(
            "notii",
            localStorage.getItem("notii") === "true" ? "false" : "true"
          );
        });
      }
    );
  }, [i18n.language]);

  const authRoutes = useMemo(
    () => [
      "/login",
      "/register",
      "/forgot-password",
      "/verification",
      "/reset-password",
      "/select-profile",
      "/create-company",
      "/register-individual",
      "/register-company",
      "/card",
    ],
    []
  );

  const isAuthPage = authRoutes.includes(location.pathname);

  const isNotFoundPage = useMemo(() => {
    return !routes.some((route) => matchPath(route.path, location.pathname));
  }, [location.pathname, routes]);

  return (
    <>
      {!isAuthPage && !isNotFoundPage && <Header />}
      <AllRoutes />
      {!isAuthPage && !isNotFoundPage && <Footer />}
      {<ChatbotWrapper />}
    </>
  );
}

export default App;
